import { render } from "./SimpleAppHeader.vue?vue&type=template&id=9ead8bb6"
import script from "./SimpleAppHeader.vue?vue&type=script&lang=js"
export * from "./SimpleAppHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/sentry/temp/sensoren/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__